import React from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';

import { useGlobalSandBox } from 'components/Dialogs/AuthDialog';

const makeTileSvg = (color: string) =>
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="320" height="200">
  <text
    x="210" y="100"
    fill="${color}"
    font-size="17"
    font-weight="700"
    font-family="sans-serif"
    text-anchor="middle"
    dominant-baseline="middle"
    transform="rotate(-30 210 100)"
    letter-spacing="2"
  >INTERNAL USE ONLY</text>
</svg>
`);

const PrototypeWatermark = React.memo(() => {
  const [sandbox] = useGlobalSandBox();
  if (!sandbox) {
    return null;
  }
  return (
    <Box
      aria-hidden='true'
      sx={(theme) => ({
        position: 'fixed',
        inset: 0,
        zIndex: theme.zIndex.tooltip + 1,
        pointerEvents: 'none',
        backgroundImage: `url("data:image/svg+xml;utf8,${makeTileSvg(alpha(theme.palette.info.main, 0.05))}")`,
        backgroundRepeat: 'repeat',
      })}
    />
  );
});

PrototypeWatermark.displayName = 'PrototypeWatermark';
export default PrototypeWatermark;
